/**
 *
 * FlashCardDetail
 *
 */

import { mapState } from 'vuex';

export default {
  name: 'DebugPanel',

  computed: {
    ...mapState('FlashCard/FlashCardDetail', {
      ms_flashCardDetail: 'flashCardDetail',
    }),
  },
};
